import type { ISVG } from './index';

/** A clock face with a rewind arrow — the "replay the day" motif. Sidebar nav icon. */
export const ResultTimeMachineSVG = ({ width, height, color }: ISVG) => (
	<svg
		xmlns='http://www.w3.org/2000/svg'
		width={width || '20'}
		height={height || '20'}
		viewBox='0 0 24 24'
		fill='none'
	>
		{/* Clock face */}
		<circle
			cx='13'
			cy='12'
			r='7.25'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
		/>
		{/* Hands, pointing back in time */}
		<path
			d='M13 8.5V12l-2.5 1.75'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
		{/* Rewind arc + arrowhead entering the face from the left */}
		<path
			d='M5.4 8.2A7.25 7.25 0 0 1 13 4.75'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
		/>
		<path
			d='M3.4 6.2 5.4 8.2l2-2'
			stroke={color || 'currentColor'}
			strokeWidth='1.5'
			strokeLinecap='round'
			strokeLinejoin='round'
		/>
	</svg>
);
